module.exports = __webpack_public_path__ + "img/changeColor-2.ccbbdcc.png";